export enum FeatureSource {
    ANOMALIES = 'anomalies',
    PROJETS_INSPECTION = 'projetsInspection',
    PROJETS_AUDIT = 'projetsAudit',
    POINTS_AUDIT = 'pointsAudit',
    POINTS_INSPECTION = 'pointsInspection'
}
